"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = now;
const fdatetime_1 = require("./fdatetime");
/**
 * aktualna data i czas w formacie yyyy-MM-dd HH:mm:ss
 */
function now() {
    return (0, fdatetime_1.fdatetime)(new Date());
}
//# sourceMappingURL=now.js.map